import { mapMutations } from 'vuex';
import Forms from '../../utils/forms/forms';
import modulesService from './../../services/modules';
import organizationSettingsService from './../../services/organizationSettings';
import unimicroService from '../../services/unimicro';

export default {
  props: {
    mod: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      form: new Forms({
        unimicro_environment: { type: 'select', value: '' },
        unimicro_invoice_series_id: { type: 'select', value: '' },
      }),

      numberSeriesOptions: [],
      savedSeriesId: null,
      loading: false,
    };
  },

  mounted() {
    this.loading = true;

    Promise.all([
      this.loadEnvironment(),
      this.loadNumberSeries(),
    ]).finally(() => {
      this.loading = false;
    });
  },

  methods: {
    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    /**
     * Load existing UniMicro settings (Environment + InvoiceSeriesId)
     */
    loadEnvironment() {
      return organizationSettingsService
        .show()
        .then((settings) => {
          settings = settings || {};
          console.log('[UniMicro] Raw settings:', settings);

          const norm = (obj, key) => {
            if (obj[key] !== undefined && obj[key] !== null) return obj[key];
            const snake = key.replace(/([A-Z])/g, '_$1').toLowerCase();
            if (obj[snake] !== undefined && obj[snake] !== null) return obj[snake];
            return '';
          };

          /*
          |----------------------------------------------------------------------
          | Load Environment
          |----------------------------------------------------------------------
          */
          let env = norm(settings, 'unimicroEnvironment');
          env = String(env).trim();

          if (typeof this.form.set === 'function') {
            this.form.set('unimicro_environment', env);
          } else {
            this.form.fields.unimicro_environment = { type: 'select', value: env };
          }

          /*
          |----------------------------------------------------------------------
          | Load Saved Invoice Series ID
          |----------------------------------------------------------------------
          */
          this.savedSeriesId = norm(settings, 'unimicroInvoiceSeriesId');

          this.form.fields.unimicro_invoice_series_id = { type: 'select', value: '' };


          return true;
        })
        .catch((err) => {
          console.error('[UniMicro] Failed to load settings:', err);
          this.$message({
            showClose: true,
            message: 'Failed to load UniMicro settings.',
            customClass: 'error',
          });
        });
    },

    /**
     * Load NUMBER SERIES from UniMicro backend
     */
    loadNumberSeries() {
      return unimicroService
        .numberSeries()
        .then((res) => {
          const apiData = res.data || {};
          const series = apiData.series || [];

          this.numberSeriesOptions = series.map((s) => ({
            label: `${s.display} (Next: ${s.next_number})`,
            value: s.id,
          }));

          console.log('[UniMicro] Loaded Invoice Series:', this.numberSeriesOptions);

          // Restore saved selection
          if (
            this.savedSeriesId &&
            this.numberSeriesOptions.some((o) => o.value == this.savedSeriesId)
          ) {
            this.form.fields.unimicro_invoice_series_id.value = Number(this.savedSeriesId);
          }
        })
        .catch((err) => {
          console.error('[UniMicro] Failed to fetch number series:', err);
          this.$message({
            showClose: true,
            message: 'Failed to fetch UniMicro number series.',
            customClass: 'error',
          });
        });
    },

    /**
     * Save Environment + Invoice Number Series
     */
    saveEnvironment() {
      this.loading = true;

      const payload = {
        module_id: this.mod.id,
        unimicro_environment: this.form.fields.unimicro_environment.value,
        unimicro_invoice_series_id: this.form.fields.unimicro_invoice_series_id.value,
      };

      modulesService
        .subscribe(this.mod.id, payload)
        .then(() => {
          this.$message({
            showClose: true,
            message: 'Settings updated successfully.',
            type: 'success',
          });

          return Promise.all([
            modulesService.items(),
            organizationSettingsService.show(),
          ]);
        })
        .catch(() => {
          this.$message({
            showClose: true,
            message: 'Failed to update UniMicro settings.',
            customClass: 'error',
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeModal() {
      this.toggleModal(false);
      this.unsetModalContent();
    },
  },

  components: {
    VForm: require('./../../components/form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/unimicroCredentialsModal/unimicroCredentialsModal.js